import { webApiWithResponse } from "../../../../../core/http/httpThunks";
import { ProductAttribute } from "../../types";

export const createAttributeApi = (userId: string, attribute: ProductAttribute) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/newprodattr",
		params: {
			userId
		},
		data: attribute
	});

export default createAttributeApi;
